<div class="twc-d-flex object-browser-filter-container">
    <ng-container *ngFor="let item of filters" [ngSwitch]="item.type">
        <ng-container *ngIf="!(item.hide && item.hide())">
            <ng-container *ngSwitchCase="objectBrowserFilterType.TOGGLE">
                <twc-toggle class="twc-mb-2" *ngIf="isVisible(item)">
                    <input twcToggleInput [checked]="item.value" (change)="toggleFilter(item)"
                        [attr.disabled]="isFilterDisabledAttr(item.disable)">
                    <label twcToggleLabel twcTooltip="{{item.tooltip ? (item.tooltip| translate) : ''}}">
                        {{ item.text ?? '' | translate}}
                    </label>
                </twc-toggle>
            </ng-container>

            <ng-container *ngSwitchCase="objectBrowserFilterType.SELECT">
                <div [style.width]="item.width ?? '10rem'">
                    <label class="label-select">{{item.text ? (item.text | translate) : ''}}</label>
                    <twc-select placeholder="{{item.placeholder ? (item.placeholder | translate) : ''}}"
                        [disabled]="isFilterDisabled(item.disable)" class="object-browser-filter-select"
                        [(ngModel)]="item.value" (ngModelChange)="selectFilter(item)">
                        <twc-select-option *ngFor="let range of item.range" [value]="range.value">
                            {{range.text | translate}}
                        </twc-select-option>
                    </twc-select>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="objectBrowserFilterType.SEARCH">
                <twc-search class="object-browser-filter-search"
                    [twcTooltip]="'OBJECT_BROWSER.SEARCH_TOOLTIP' | translate" placement="bottom"
                    (cleared)="searchFilter('', item)">
                    <input type="text" twcSearchInput (cwDebounceKeyUp)="searchFilter($event, item)"
                        [attr.disabled]="isFilterDisabledAttr(item.disable)" [cwDebounceKeyUpTime]="500"
                        placeholder="{{item.placeholder? (item.placeholder | translate) : ''}}" [ngModel]="item.value">
                </twc-search>
            </ng-container>

            <div class="object-browser-filter-search" [class.filter-disabled]="autocompleteDisabled"
                *ngSwitchCase="objectBrowserFilterType.AUTOCOMPLETE">
                <cw-autocomplete [dataList]="item.shownItems ?? []" [filterType]="3"
                    placeholder="{{item.placeholder? (item.placeholder | translate) : ''}}" [loading]="loading"
                    (searchTextChange)="item.autocompleteSearchFn?.($event)" [hiddenOptionInfo]="true"
                    (selectedOptionChange)="autocompleteFilter($event, item)" [floating]="true"
                    [selectedOptionInfo]="item.value">
                </cw-autocomplete>
            </div>
        </ng-container>
    </ng-container>

    <button qaid="filter-reset" *ngIf="!isFilterReset" type="button" class="twc-button twc-button-link twc-ml-3"
        [attr.disabled]="areFiltersDisabled || null" (click)="resetFilters()">
        {{'OBJECT_BROWSER.RESET_FILTERS' | translate}}
    </button>
</div>